module.exports = __webpack_public_path__ + "static/media/auditorium-door-open.4ae081ca.png";